import type { Parsed } from '~/utils/parsed';

// Mirrors backend PiecesPerBundleBounds.java.
export const MIN_PIECES_PER_BUNDLE = 1;
export const MAX_PIECES_PER_BUNDLE = 99_999;

export const bundleSizeMessageParams = {
  min: MIN_PIECES_PER_BUNDLE.toLocaleString('en-US'),
  max: MAX_PIECES_PER_BUNDLE.toLocaleString('en-US'),
};

export function parseBundleSize(raw: string): Parsed<number> {
  const text = raw.trim();
  if (!/^\d+$/.test(text)) {
    return { valid: false };
  }
  const value = Number(text);
  return value >= MIN_PIECES_PER_BUNDLE && value <= MAX_PIECES_PER_BUNDLE
    ? { valid: true, value }
    : { valid: false };
}
